namespace TabAurous.ECommerce {
    export interface ECommOrderAddressForm {
        Address1: Serenity.StringEditor;
        City: Serenity.IntegerEditor;
        State: Serenity.IntegerEditor;
        Country: Serenity.IntegerEditor;
        Pincode: Serenity.StringEditor;
        CityName: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        CountryName: Serenity.StringEditor;
    }

    export class ECommOrderAddressForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommOrderAddress';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommOrderAddressForm.init)  {
                ECommOrderAddressForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(ECommOrderAddressForm, [
                    'Address1', w0,
                    'City', w1,
                    'State', w1,
                    'Country', w1,
                    'Pincode', w0,
                    'CityName', w0,
                    'StateName', w0,
                    'CountryName', w0
                ]);
            }
        }
    }
}
